import { Application } from '../enums/application.enum';

export interface IUserApps {
  application: Application;
  path: string;
  name: string;
}
